import styled from '@emotion/styled'

import { mq } from '../../constants/breakpoints'

export const LabelList = styled.div``

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div {
    margin: 15px;
  }
`
export const ShowFiltersButton = styled.button<{ textColor?: string; hoverColor?: string }>`
  color: ${(props) => (props.textColor ? props.textColor : 'blue')};
  font-size: 1rem;

  &:hover {
    color: ${(props) => (props.hoverColor ? props.hoverColor : 'blue')};
  }
`

export const ClearFiltersButton = styled.button<{ textColor?: string; hoverColor?: string }>`
  margin-left: 10px;
  color: ${(props) => (props.textColor ? props.textColor : 'blue')};
  font-size: 0.9rem;

  &:hover {
    color: ${(props) => (props.hoverColor ? props.hoverColor : 'blue')};
  }
`

export const SelectedFiltersList = styled.div<{ filtersVisible?: boolean }>`
  display: flex;
  padding: ${(props) => (props.filtersVisible ? '0 10px' : 0)};
  flex-wrap: wrap;

  & > div {
    margin: 5px;
  }
`

export const FilterItem = styled.div<{ backgroundColor?: string; textColor?: string }>`
  padding: 5px 10px;
  border-radius: 3px;
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : '#0076ff')};
  color: ${(props) => (props.textColor ? props.textColor : 'white')};
  font-size: 0.8rem;
  display: flex;
  align-items: center;

  button {
    margin-left: 10px;
    margin-right: -2px;
  }

  svg {
    display: block;
  }
`

export const ButtonPart = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;

  ${mq.mobile} {
    justify-content: flex-start;
  }
`
